import { CallsTab } from '@/features/customers/components/Detail/Tabs/CallsTab';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/customers/customer/$id/calls')({
  component: CallsTab,
});
